const ab = {
  // ==================== ORDER CONFIRMATION CAPTURE ====================
  'ab.title': 'Order Confirmation Capture',
  'ab.subtitle': 'Upload the order confirmation PDF, review the lines and check them against the purchase order',
  'ab.inDevelopmentDesc': 'Order Confirmation Capture will automatically read the supplier confirmation via OCR and run AI-assisted checks against the corresponding MM purchase order (quantity, price, delivery date) — including deviation hints and an approval workflow.',

  // ---- Header ----
  'ab.uploadButton': 'Upload',
  'ab.uploadHide': 'Hide',
  'ab.ocrUnreachable': 'OCR service unreachable',

  // ---- KPI tiles ----
  'ab.kpiNeedsReview': 'Needs review',
  'ab.kpiNoRuleset': 'No ruleset',
  'ab.kpiFailed': 'Failed',
  'ab.kpiApproved7d': 'Approved (7 days)',

  // ---- Upload dropzone ----
  'ab.uploadDropzoneTitle': 'Drop the order confirmation PDF here',
  'ab.uploadDropzoneHint': 'or choose a file — PDF only, max. 20 MB',
  'ab.uploadBusy': 'Uploading and processing…',
  'ab.uploadOk': 'Uploaded — {n} line(s) detected',
  'ab.uploadError': 'Upload failed',
  'ab.uploadOnlyPdf': 'Only PDF files are supported',
  'ab.uploadTooLarge': 'File is too large (max. 20 MB)',

  // ---- Document list ----
  'ab.tabOpen': 'Open',
  'ab.tabDone': 'Done',
  'ab.searchPlaceholder': 'Search file, supplier or PO number…',
  'ab.refresh': 'Refresh',
  'ab.colFile': 'File',
  'ab.colSupplier': 'Supplier',
  'ab.colOrder': 'PO',
  'ab.colLines': 'Lines',
  'ab.colCompare': 'Comparison',
  'ab.colWarnings': 'Warnings',
  'ab.colStatus': 'Status',
  'ab.colCreated': 'Created on',
  'ab.colPos': 'Pos.',
  'ab.supplierUnknown': 'Unknown',
  'ab.listEmpty': 'No documents found',
  'ab.listLoadError': 'Could not load list',
  'ab.loading': 'Loading…',
  'ab.pageInfo': 'Page {page} of {totalPages} · {total} document(s)',

  // ---- Status (traffic light, ab_documents.status) ----
  'ab.status.processing': 'Processing',
  'ab.status.needs_review': 'Needs review',
  'ab.status.no_ruleset': 'No ruleset',
  'ab.status.failed': 'Failed',
  'ab.status.approved': 'Approved',
  'ab.status.rejected': 'Rejected',

  // ---- Detail view ----
  'ab.detailLoadError': 'Document could not be loaded',
  'ab.pdfView': 'Order confirmation preview',
  'ab.pdfHide': 'Hide',
  'ab.pdfShow': 'Show PDF',
  'ab.pdfLoading': 'Loading PDF…',
  'ab.headerData': 'Header data',
  'ab.approvedOn': 'Approved on {date}',
  'ab.rejectReasonLabel': 'Rejection reason',

  // ---- Comparison against the purchase order ----
  'ab.compareTitle': 'Comparison against purchase order',
  'ab.compareOk': '{n} matching',
  'ab.compareDiff': '{n} differing',
  'ab.compareNotFound': '{n} not found',
  'ab.compare.state.ok': 'Matching',
  'ab.compare.state.diff': 'Differing',
  'ab.compare.state.not_found': 'Not found',
  'ab.compare.tooltip': 'Confirmation: {ab} / PO: {po}',

  // ---- Warnings ----
  'ab.warningsTitle': 'Warnings',

  // ---- Line table ----
  'ab.linesTitle': 'Lines',
  'ab.noLines': 'No lines captured',
  'ab.addLine': 'Add line',
  'ab.confirmDeleteLine': 'Really delete?',
  'ab.field.ebeln': 'PO number',
  'ab.field.ebelp': 'PO line',
  'ab.field.labnr': 'Confirmation number',
  'ab.field.matnr': 'Material number',
  'ab.field.mfrpn': 'Manufacturer part no.',
  'ab.field.menge': 'Quantity',
  'ab.field.netpr': 'Price',
  'ab.field.eeind': 'Delivery date',
  'ab.field.waers': 'Currency',
  'ab.field.supplier': 'Supplier',

  // ---- Actions ----
  'ab.approve': 'Approve',
  'ab.approveDialogTitle': 'Approve order confirmation?',
  'ab.approveDialogMsg': 'The lines will be marked as reviewed. This action cannot be undone.',
  'ab.approvedMsg': 'Order confirmation approved',
  'ab.reject': 'Reject',
  'ab.rejectDialogTitle': 'Reject order confirmation',
  'ab.rejectReasonPlaceholder': 'Reason for rejection…',
  'ab.rejectReasonRequired': 'Please provide a rejection reason',
  'ab.rejectedMsg': 'Order confirmation rejected',
  'ab.reprocess': 'Reprocess',
  'ab.reprocessDialogTitle': 'Reprocess?',
  'ab.reprocessDialogMsg': 'All lines will be deleted and re-extracted via OCR. Manual edits will be lost.',
  'ab.reprocessedMsg': 'Reprocessing started',
  'ab.deleteDialogTitle': 'Delete document?',
  'ab.deleteDialogMsg': 'The document, its file and all lines will be permanently deleted.',
  'ab.deletedMsg': 'Document deleted',
  'ab.lineAddedMsg': 'Line added',
  'ab.lineDeletedMsg': 'Line deleted',

  // ---- Timeline (ab_events) ----
  'ab.timeline': 'History',
  'ab.event.uploaded': 'Uploaded',
  'ab.event.extracted': 'Lines extracted',
  'ab.event.line_edited': 'Line edited',
  'ab.event.line_added': 'Line added',
  'ab.event.line_deleted': 'Line deleted',
  'ab.event.reprocessed': 'Reprocessed',
  'ab.event.approved': 'Approved',
  'ab.event.rejected': 'Rejected',
  'ab.event.failed': 'Processing failed',
  'ab.event.sap_committed': 'SAP posting successful',
  'ab.event.commit_failed': 'SAP posting failed',
  'ab.event.suggest_started': 'AI ruleset suggestion started',
  'ab.event.suggest_done': 'AI ruleset suggestion created',
  'ab.event.suggest_applied': 'AI ruleset suggestion applied as draft',

  // ==================== RULESET MANAGEMENT (admin) ====================
  'ab.rulesetsButton': 'Rulesets',
  'ab.rulesetsTitle': 'Ruleset management',
  'ab.rulesetsLoadError': 'Could not load rulesets',
  'ab.rulesetsEmpty': 'No rulesets created yet',
  'ab.rulesetNewVersion': 'New version',
  'ab.rulesetEdit': 'Edit',
  'ab.rulesetActivate': 'Activate',
  'ab.rulesetDeactivate': 'Deactivate',
  'ab.rulesetDeleteActiveHint': 'The active version cannot be deleted — deactivate it first',
  'ab.rulesetVersion': 'Version {v}',
  'ab.rulesetActivatedMsg': 'Ruleset activated',
  'ab.rulesetDeactivatedMsg': 'Ruleset deactivated',
  'ab.rulesetDeletedMsg': 'Ruleset deleted',
  'ab.rulesetSavedMsg': 'Ruleset saved as draft',
  'ab.rulesetConfirmDeleteTitle': 'Delete ruleset?',
  'ab.rulesetConfirmDeleteMsg': 'Ruleset "{supplier}" version {version} will be permanently deleted.',
  'ab.rulesetSupplierIdLabel': 'Supplier ID',
  'ab.rulesetSupplierNameLabel': 'Supplier name',
  'ab.rulesetJsonLabel': 'Ruleset (JSON)',
  'ab.rulesetJsonInvalid': 'Invalid JSON: {error}',
  'ab.rulesetRequiredFields': 'Please provide supplier ID, supplier name and valid JSON',
  'ab.rulesetPreviewTitle': 'Preview',
  'ab.rulesetPreviewDocPlaceholder': '– Choose document –',
  'ab.rulesetPreviewDocRequired': 'Please choose a test document first',
  'ab.rulesetPreviewButton': 'Run preview',
  'ab.rulesetPreviewRunning': 'Running preview…',
  'ab.rulesetPreviewResult': '{lineCount} line(s) detected',
  'ab.rulesetPreviewError': 'Preview failed',
  'ab.rulesetPreviewEmptyHint': 'Choose a document and run the preview',

  // ==================== AI RULESET SUGGESTION ====================
  'ab.suggestTitle': 'Suggest AI ruleset',
  'ab.suggestDesc': 'No matching ruleset is configured for this supplier. The AI can propose a ruleset draft based on the document.',
  'ab.suggestButton': 'Suggest AI ruleset',
  'ab.suggestStarting': 'Starting…',
  'ab.suggestRunning': 'AI is generating a ruleset suggestion…',
  'ab.suggestNotConfigured': 'AI suggestion is not configured (LLM access missing)',
  'ab.suggestAdminOnly': 'AI suggestions can only be started by administrators — please contact your admin.',
  'ab.suggestAlreadyRunning': 'An AI suggestion is already running for this document',
  'ab.suggestTimeout': 'Timed out waiting for the AI result',
  'ab.suggestFailed': 'AI suggestion failed',
  'ab.suggestRetryButton': 'Retry',
  'ab.suggestResultSummary': '{lineCount} line(s) detected',
  'ab.suggestApplyButton': 'Apply as draft',
  'ab.suggestApplyHint': 'The ruleset is created as an inactive draft — please activate it in the ruleset management and reprocess the document afterwards.',
  'ab.suggestAppliedMsg': 'AI suggestion applied as ruleset draft',

  // ==================== SAP COMMIT RESULT ====================
  'ab.commitResultTitleSuccess': 'SAP posting successful',
  'ab.commitResultTitleFailed': 'SAP posting failed',
  'ab.commitResultFailedHint': 'The status stays "Needs review" — please fix the error and approve again.',
  'ab.commitResultNoGroups': 'No purchase orders found to post.',
  'ab.commitLineLabel': 'Line {ebelp}',
  'ab.commitFailedMsg': 'SAP posting failed',
  'ab.fourEyesTitle': 'Approval blocked',

  // ==================== MAIL INGESTION (admin) ====================
  'ab.mailEnabledChip': 'Mail ingestion active ({n})',
  'ab.mailDisabledChip': 'Mail ingestion off',
  'ab.mailDisabledHint': 'Mail ingestion is disabled (AB_MAIL_ENABLED) — clicking still attempts a run',
  'ab.mailNoRunYet': 'No run yet',
  'ab.mailLastRunTooltip': 'Last run {finishedAt}: {found} found, {processed} processed, {ignored} ignored, {failed} failed',
  'ab.mailSyncStarted': 'Mail sync started',
};

export default ab;
